import { TUserAvatarProps } from './UserAvatar.types';
import React, { useRef, useState } from 'react';
import s from './UserAvatar.module.scss';
import { batch, useSelector } from 'react-redux';
import { selectIsModalOpened } from 'src/redux/modals/modals.selectors';
import { useModal } from 'src/hooks/useModal';
import { useAppDispatch } from 'src/redux/store';
import { closeModal, openModal } from 'src/redux/modals/modals.slice';
import profileImg from 'src/assets/images/profile-img.png';
import { BaseOverflowMenu } from 'src/components/BaseOverflowMenu';
import { EModalSize } from 'src/constants/modals';
import { BaseClose } from 'src/components/BaseClose';
import { FormEditPassword } from 'src/components/FormEditPassword';
import classnames from 'classnames';
import { setTokenAuth } from 'src/redux/auth/auth.slice';
import { BaseButton } from 'src/components/BaseButton';
import { useConfigurationUtils } from 'src/hooks/useConfigurationUtils';
import { selectUsername } from 'src/redux/auth/auth.selectors';

export const UserAvatar: React.FC<TUserAvatarProps> = () => {
  const modalRef = useRef<HTMLButtonElement>(null);
  const { id: userMenuModalId } = useModal();
  const { discardCurrentConfiguration } = useConfigurationUtils();
  const isUserMenuOpened = useSelector(selectIsModalOpened(userMenuModalId));
  const [showEditPassword, setShowEditPassword] = useState(false);
  const dispatch = useAppDispatch();
  const username = useSelector(selectUsername);

  const dropDownItems = [
    {
      title: 'Logout',
      onClick: () => {
        batch(() => {
          discardCurrentConfiguration({
            zoomOut: true,
          });
          dispatch(setTokenAuth(null));
        });
      },
    },
    {
      title: 'Edit Password',
      onClick: () => setShowEditPassword(true),
    },
  ];

  const EditPasswordComponent = (
    <div>
      <BaseClose className={s.closeBtn} onClick={() => setShowEditPassword(false)} />
      <FormEditPassword />
    </div>
  );

  const AvatarDropdownComponent = (
    <>
      <span className={classnames(s.menuItem, s.username, s.menuItemBottomBorder)}>{username}</span>
      {dropDownItems.map((item, index) => (
        <BaseButton
          className={classnames(s.menuItem, {
            [s.menuItemBottomBorder]: index !== dropDownItems.length - 1,
          })}
          key={index}
          onClick={item.onClick}>
          {item.title}
        </BaseButton>
      ))}
    </>
  );

  return (
    <>
      <button
        ref={modalRef}
        className={s.profileBtn}
        type="button"
        onClick={() => {
          if (isUserMenuOpened) {
            dispatch(closeModal(userMenuModalId));
          } else {
            dispatch(openModal(userMenuModalId));
          }
        }}>
        <img src={profileImg} alt="" />
      </button>
      {/* User menu */}
      <BaseOverflowMenu
        relativeElement={modalRef}
        modalId={userMenuModalId}
        position={{
          side: 'bottom',
          anchorPosition: 85,
        }}
        size={showEditPassword ? EModalSize.M250 : EModalSize.S115}
        className={s.profileMenu}>
        {showEditPassword ? EditPasswordComponent : AvatarDropdownComponent}
      </BaseOverflowMenu>
    </>
  );
};
